import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function Dashboard() {
    const { user, loading } = useAuth();
    if (loading) return <div className="pt-32 text-center text-zinc-500 text-sm tracking-label uppercase">Loading…</div>;
    if (!user) return <Navigate to="/login" replace />;
    if (user.user_type === "admin") return <Navigate to="/dashboard/admin" replace />;
    if (user.user_type === "provider") return <Navigate to="/dashboard/provider" replace />;
    return <Navigate to="/dashboard/client" replace />;
}
